import type { FC } from 'react'

import { colors, dimensions } from '@factorialco/deprecated-design-system'

interface Props {
  height: number
}

const Line: FC<Props> = ({ height }) => {
  return (
    <svg height={height} width="100%">
      <line
        x1="50%"
        y1="0"
        x2="50%"
        y2={height}
        style={{
          stroke: colors.grey400,
          strokeWidth: dimensions.s2,
          strokeLinecap: 'round',
        }}
      />
    </svg>
  )
}

export default Line
